export const getUrl = (url) => {
  return url.split(/[#?]/)[0].split('.').pop().trim()
}